import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

export const FilterCard = ({ className, children }) => {
  return (
    <Card className={cn("mb-6", className)}>
      <CardContent className="p-4">
        <div className="flex flex-col md:flex-row items-center gap-4">
          {children}
        </div>
      </CardContent>
    </Card>
  );
};

export const FilterSearch = ({
  value,
  onChange,
  placeholder = "Search...",
  className,
}) => {
  return (
    <div className={cn("relative flex-1 w-full", className)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground h-4 w-4" />
      <Input
        placeholder={placeholder}
        className="pl-9 w-full"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export const FilterActions = ({ className, children }) => {
  return (
    <div className={cn("flex items-center gap-2 w-full md:w-auto", className)}>
      {children}
    </div>
  );
};
